export default "__VITE_ASSET__e95214b7__"